import { React } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  PageHeader,
  Upload,
  message,
} from "antd";
import "antd/dist/antd.css";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useLocation, useNavigate } from "react-router-dom";
//import PreparingUploadOrders from "./preparingUploadOrders";
import { useEffect, useState } from "react";
import { newUploadOrders, uploadFile } from "../../../Services/uploadServices";
import {
  getAllUploadFormats,
  getUploadFormats,
} from "../../../Services/settingsServices";
import { getUserEmailId } from "../../../Services/localStorageServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getImageURL } from "../../../Services/deckleMatchServices";

const { Dragger } = Upload;

const ImportCustomer = (props) => {
  const location = useLocation();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [template, setTemplate] = useState();

   const fileUploadData = {
  name: "file",
  multiple: false,
  maxCount: 1,
  listType: "picture",
  accept: ".csv,.xls,.xlsx",
  beforeUpload: () => false, // prevent auto upload
  fileList: fileList, // controlled file list
  onChange(info) {
    const { file } = info;
    const ext = file?.name?.split(".").pop().toLowerCase();

    // Block SVG or invalid files
    if (ext !== "csv" && ext !== "xls" && ext !== "xlsx") {
      setActionToaster({
        error: true,
        msg: "Invalid file type. Only CSV, XLS and XLSX files are allowed.",
      });
      setVisibleToaster(true);
      setTimeout(() => setVisibleToaster(false), 3000);

      // Remove blocked file from UI
      setFileList(prev => prev.filter(f => f.uid !== file.uid));
      return;
    }

    if (info.file.status !== "uploading") {
      setUploadedFile(info?.fileList[0]?.originFileObj);
      setFileList([file]); // keep only the latest file
    }
  },
  onRemove(file) {
    // Fully clear the state
    setUploadedFile(null);
    setFileList([]);
    return false; // Prevent AntD default remove handling
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};

  const history = useNavigate();

  useEffect(() => {
    (async () => {
      if (location.state?.error || location.state?.isFileEmpty) {
        setActionToaster({
          error: true,
          msg:
            location.state?.fileEmptyKey == "no data"
              ? location.state.msg
              : "Format is incorrect. Please upload correct format",
        });
        showToaster();
      }
      await getAllUploadFormats()
        .then((response) => {
          let body = {
            bucket_key: response.data.data.customers.template,
            operation:"download"

          };
          getImageURL(body).then((url) => {
            setTemplate(url);
          })
        })
        .catch((error) => {
          console.log(error);
        });
    })();
  }, []);

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 3000);
  };

  const uploadCustomers = async () => {
    const userEmailId = getUserEmailId();
    const res = await getImageURL({ bucket_key: `${userEmailId}/${uploadedFile.name}`,operation:"upload"});
    await newUploadOrders(res,uploadedFile);
    // await uploadFile(uploadedFile);
    history("../customer-records/preparing-upload-customers", {
      state: {
        action: `${userEmailId}/${uploadedFile.name}`,
      },
    });
  };

  const GoBackRouteChange = () => {
    history("../customer-records");
  };

 
  return (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          onBack={() => history("../customer-records")}
          title="Upload Customers"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={GoBackRouteChange}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
            <Button
              key="1"
              className="themeBtn"
              onClick={uploadCustomers}
              disabled={uploadedFile ? false : true}
            >
              <Iconmoon icon="move-right" size={14} color="#ffffff" />
              Next
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        {/* <HaberForm> */}
        <div className="groupDetailWrap">
          <Form name="basic" autoComplete="off" className="haberLogin">
            <Row gutter={[16, 16]} className="groupForm lastGroup">
              <Col span={8}>
                <GroupTitle>
                  <h2>Upload File</h2>
                  <p>
                    You can upload a customers in a valid format. <br></br>
                    You need to fill your customers data in same format and{" "}
                    <br></br>
                    upload the file to add customers in Kaiznn
                  </p>
                  {/* <a style={{"color":"#EA655B"}}> Download excel format</a> */}
                </GroupTitle>
              </Col>
              <Col span={16}>
                <Row className="centerAlign">
                  <Col span={12}>
                    <div className="boxFieldTitle">
                      <p>Upload customers details in the attached template </p>
                      <a
                        href={template ? `${template}` : "#"}
                        style={{ color: "#EA655B" }}
                      >
                        {" "}
                        Download template
                      </a>
                    </div>
                  </Col>
                  <Col span={12} className="blockBreak">
                    <div
                      className="boxFormType csv-file"
                      style={{ marginBottom: "0" }}
                    >
                      <Dragger {...fileUploadData}>
                        <p className="ant-upload-drag-icon">
                          <Iconmoon
                            icon="upload-image"
                            size={18}
                            color="#A19F9D"
                          />{" "}
                        </p>
                        <p className="ant-upload-text">
                          <span>Click to add</span> or drag and drop
                        </p>
                        <p className="ant-upload-hint">
                          CSV or Excel (max. 1 MB)
                        </p>
                      </Dragger>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
        {/* </HaberForm> */}
      </DetailFields>
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}
    </RightLayoutContainer>
  );
};

export default ImportCustomer;
